function i(i,o,a,e){i._m(o),i.o(o,"SimpleKeyboard",()=>i.f(f));var f=i.i(a("86885006"));}